/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  DAOAccessControl,
  DAOAccessControlInterface,
} from "../../../../@fractal-framework/core-contracts/contracts/DAOAccessControl";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
    ],
    name: "MissingRole",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlySelfRenounce",
    type: "error",
  },
  {
    inputs: [],
    name: "UnequalArrayLengths",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "functionDesc",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "encodedSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
    ],
    name: "ActionRoleAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "functionDesc",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "encodedSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
    ],
    name: "ActionRoleRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "previousAdminRole",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "adminRole",
        type: "string",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DAO_ROLE",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPEN_ROLE",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "sig",
        type: "bytes4",
      },
    ],
    name: "actionIsAuthorized",
    outputs: [
      {
        internalType: "bool",
        name: "isAuthorized",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "adminGrantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "adminRevokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "string[]",
        name: "functionDescs",
        type: "string[]",
      },
      {
        internalType: "string[][]",
        name: "roles",
        type: "string[][]",
      },
    ],
    name: "daoAddActionsRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "roles",
        type: "string[]",
      },
      {
        internalType: "address[][]",
        name: "members",
        type: "address[][]",
      },
    ],
    name: "daoGrantRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "roles",
        type: "string[]",
      },
      {
        internalType: "string[]",
        name: "roleAdmins",
        type: "string[]",
      },
      {
        internalType: "address[][]",
        name: "members",
        type: "address[][]",
      },
    ],
    name: "daoGrantRolesAndAdmins",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "string[]",
        name: "functionDescs",
        type: "string[]",
      },
      {
        internalType: "string[][]",
        name: "roles",
        type: "string[][]",
      },
    ],
    name: "daoRemoveActionsRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "string",
        name: "functionDesc",
        type: "string",
      },
    ],
    name: "getActionRoles",
    outputs: [
      {
        internalType: "string[]",
        name: "roles",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dao",
        type: "address",
      },
      {
        internalType: "string[]",
        name: "roles",
        type: "string[]",
      },
      {
        internalType: "string[]",
        name: "roleAdmins",
        type: "string[]",
      },
      {
        internalType: "address[][]",
        name: "members",
        type: "address[][]",
      },
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "string[]",
        name: "functionDescs",
        type: "string[]",
      },
      {
        internalType: "string[][]",
        name: "actionRoles",
        type: "string[][]",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "string",
        name: "functionDesc",
        type: "string",
      },
    ],
    name: "isRoleAuthorized",
    outputs: [
      {
        internalType: "bool",
        name: "isAuthorized",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "userRenounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60a06040523060805234801561001457600080fd5b5060805161293e61004c600039600081816104130152818161045c015281816104fb0152818161053b01526105ce015261293e6000f3fe6080604052600436106101145760003560e01c80637b16e01f116100a0578063ddacc1a011610064578063ddacc1a014610315578063e34372ba14610335578063e9c2651814610355578063f9d68d8a14610389578063ff12fbd4146103a957600080fd5b80637b16e01f146102685780639f9aba6b14610288578063a74c3199146102a8578063b658f462146102c8578063cfb0a659146102e857600080fd5b806362777310116100e757806362777310146101a6578063672a41a1146101c65780636a928e8f146101f35780636c9cd097146102285780637033f4321461024857600080fd5b806301ffc9a7146101195780633659cfe61461014e5780634f1ef2861461017057806352d1902d14610183575b600080fd5b34801561012557600080fd5b50610139610134366004611d70565b6103c9565b60405190151581526020015b60405180910390f35b34801561015a57600080fd5b5061016e610169366004611da2565b610409565b005b61016e61017e366004611e5a565b6104f1565b34801561018f57600080fd5b506101986105c1565b604051908152602001610145565b3480156101b257600080fd5b5061016e6101c1366004611edb565b610674565b3480156101d257600080fd5b506101e66101e1366004611f28565b610696565b6040516101459190611fbc565b3480156101ff57600080fd5b506101e6604051806040016040528060098152602001684f50454e5f524f4c4560b81b81525081565b34801561023457600080fd5b50610139610243366004611edb565b610749565b34801561025457600080fd5b50610139610263366004611fcf565b6107e1565b34801561027457600080fd5b5061016e610283366004612209565b61099c565b34801561029457600080fd5b5061016e6102a3366004611edb565b6109d1565b3480156102b457600080fd5b5061016e6102c33660046122e1565b6109ee565b3480156102d457600080fd5b5061016e6102e3366004611edb565b610a2a565b3480156102f457600080fd5b50610308610303366004612368565b610a5d565b60405161014591906123ab565b34801561032157600080fd5b5061016e61033036600461240d565b610b83565b34801561034157600080fd5b5061016e6103503660046122e1565b610bb9565b34801561036157600080fd5b506101e66040518060400160405280600881526020016744414f5f524f4c4560c01b81525081565b34801561039557600080fd5b5061016e6103a436600461248a565b610ce8565b3480156103b557600080fd5b506101396103c4366004612590565b610e95565b60006301ffc9a760e01b6001600160e01b03198316148061040357506001600160e01b0319821660009081526020819052604090205460ff165b92915050565b6001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016300361045a5760405162461bcd60e51b8152600401610451906125d3565b60405180910390fd5b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166104a36000805160206128c2833981519152546001600160a01b031690565b6001600160a01b0316146104c95760405162461bcd60e51b81526004016104519061261f565b6104d281610fde565b604080516000808252602082019092526104ee91839190611009565b50565b6001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036105395760405162461bcd60e51b8152600401610451906125d3565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166105826000805160206128c2833981519152546001600160a01b031690565b6001600160a01b0316146105a85760405162461bcd60e51b81526004016104519061261f565b6105b182610fde565b6105bd82826001611009565b5050565b6000306001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146106615760405162461bcd60e51b815260206004820152603860248201527f555550535570677261646561626c653a206d757374206e6f742062652063616c60448201527f6c6564207468726f7567682064656c656761746563616c6c00000000000000006064820152608401610451565b506000805160206128c283398151915290565b61067d82610696565b6106878133611174565b610691838361119f565b505050565b60606066826040516106a8919061266b565b908152602001604051809103902060010180546106c490612687565b80601f01602080910402602001604051908101604052809291908181526020018280546106f090612687565b801561073d5780601f106107125761010080835404028352916020019161073d565b820191906000526020600020905b81548152906001019060200180831161072057829003601f168201915b50505050509050919050565b6040805180820190915260098152684f50454e5f524f4c4560b81b6020918201528251908301206000907f105f9fac1d35665bc3683b5b0c275c6b11ccdc5700dc819da045f601cf314f5c016107a157506001610403565b6066836040516107b1919061266b565b90815260408051602092819003830190206001600160a01b0385166000908152925290205460ff16905092915050565b600080826040516020016107f5919061266b565b60408051601f1981840301815282825280516020918201206001600160a01b0388166000908152606783528381206001600160e01b031983168252835283812080548085028701850190955284865291955093929091849084015b828210156108fc57838290600052602060002001805461086f90612687565b80601f016020809104026020016040519081016040528092919081815260200182805461089b90612687565b80156108e85780601f106108bd576101008083540402835291602001916108e8565b820191906000526020600020905b8154815290600101906020018083116108cb57829003601f168201915b505050505081526020019060010190610850565b5050825192935060009150505b8181101561099057828181518110610923576109236126c1565b602002602001015160405160200161093b919061266b565b6040516020818303038152906040528051906020012089896040516020016109649291906126d7565b60405160208183030381529060405280519060200120036109885760019450610990565b600101610909565b50505050949350505050565b6040518060400160405280600881526020016744414f5f524f4c4560c01b8152506109c78133611174565b6106918383611230565b6109da82610696565b6109e48133611174565b61069183836112f0565b6040518060400160405280600881526020016744414f5f524f4c4560c01b815250610a198133611174565b610a24848484611376565b50505050565b6001600160a01b0381163314610a535760405163d8e5629560e01b815260040160405180910390fd5b6105bd82826112f0565b6060600082604051602001610a72919061266b565b60408051601f1981840301815282825280516020918201206001600160a01b0388166000908152606783528381206001600160e01b031983168252835283812080548085028701850190955284865291955090929184015b82821015610b76578382906000526020600020018054610ae990612687565b80601f0160208091040260200160405190810160405280929190818152602001828054610b1590612687565b8015610b625780601f10610b3757610100808354040283529160200191610b62565b820191906000526020600020905b815481529060010190602001808311610b4557829003601f168201915b505050505081526020019060010190610aca565b5050505091505092915050565b6040518060400160405280600881526020016744414f5f524f4c4560c01b815250610bae8133611174565b610a24848484611479565b6040518060400160405280600881526020016744414f5f524f4c4560c01b815250610be48133611174565b8251845114610c06576040516311e86f7360e01b815260040160405180910390fd5b8151845114610c28576040516311e86f7360e01b815260040160405180910390fd5b835160005b81811015610ce0576000848281518110610c4957610c496126c1565b602002602001015151905060005b81811015610cd657610cce888481518110610c7457610c746126c1565b6020026020010151888581518110610c8e57610c8e6126c1565b6020026020010151888681518110610ca857610ca86126c1565b60200260200101518481518110610cc157610cc16126c1565b6020026020010151611557565b600101610c57565b5050600101610c2d565b505050505050565b600154610100900460ff1615808015610d0557506001805460ff16105b80610d1e5750303b158015610d1e57506001805460ff16145b610d815760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b6064820152608401610451565b6001805460ff1916811790558015610da3576001805461ff0019166101001790555b85518751141580610db657508451875114155b80610dc357508251845114155b80610dd057508151845114155b15610dee576040516311e86f7360e01b815260040160405180910390fd5b610e186040518060400160405280600881526020016744414f5f524f4c4560c01b8152508961119f565b610e23878787611479565b610e2e848484611376565b610e366117a7565b610e46637919c7cf60e11b611814565b8015610e8b576001805461ff00191681556040519081527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b5050505050505050565b6001600160a01b03821660009081526067602090815260408083206001600160e01b031985168452825280832080548251818502810185019093528083528493849084015b82821015610f86578382906000526020600020018054610ef990612687565b80601f0160208091040260200160405190810160405280929190818152602001828054610f2590612687565b8015610f725780601f10610f4757610100808354040283529160200191610f72565b820191906000526020600020905b815481529060010190602001808311610f5557829003601f168201915b505050505081526020019060010190610eda565b5050825192935060009150505b81811015610fd457610fbe838281518110610fb057610fb06126c1565b602002602001015188610749565b15610fcc5760019350610fd4565b600101610f93565b5050509392505050565b6040518060400160405280600881526020016744414f5f524f4c4560c01b8152506105bd8133611174565b7f4910fdfa16fed3260ed0e7147f7cc6da11a60208b5b9406d12a635614ffd91435460ff161561103c5761069183611893565b826001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015611096575060408051601f3d908101601f19168201909252611093918101906126e7565b60015b6110f95760405162461bcd60e51b815260206004820152602e60248201527f45524331393637557067726164653a206e657720696d706c656d656e7461746960448201526d6f6e206973206e6f74205555505360901b6064820152608401610451565b6000805160206128c283398151915281146111685760405162461bcd60e51b815260206004820152602960248201527f45524331393637557067726164653a20756e737570706f727465642070726f786044820152681a58589b195555525160ba1b6064820152608401610451565b5061069183838361192f565b61117e8282610749565b6105bd57808260405163e76ed20960e01b8152600401610451929190612700565b6111a98282610749565b6105bd5760016066836040516111bf919061266b565b90815260408051602092819003830181206001600160a01b038616600090815293529120805460ff1916921515929092179091557fe0ca4f6d52d59033a91ab89e93c98f9acada14e0086d8b1038284f42e6d532579061122490849084903390612724565b60405180910390a15050565b8051825114611252576040516311e86f7360e01b815260040160405180910390fd5b815160005b81811015610a24576000838281518110611273576112736126c1565b602002602001015151905060005b818110156112e6576112de86848151811061129e5761129e6126c1565b60200260200101518685815181106112b8576112b86126c1565b602002602001015183815181106112d1576112d16126c1565b602002602001015161119f565b600101611281565b5050600101611257565b6112fa8282610749565b156105bd576000606683604051611311919061266b565b90815260408051602092819003830181206001600160a01b038616600090815293529120805460ff1916921515929092179091557ff3a2b91552b535c273a48d8b7453c8b0b287e20e51d74121eb50d975dbaa506d9061122490849084903390612724565b8151835114611398576040516311e86f7360e01b815260040160405180910390fd5b80518351146113ba576040516311e86f7360e01b815260040160405180910390fd5b825160005b818110156114725760008382815181106113db576113db6126c1565b602002602001015151905060005b8181101561146857611460878481518110611406576114066126c1565b6020026020010151878581518110611420576114206126c1565b602002602001015187868151811061143a5761143a6126c1565b60200260200101518481518110611453576114536126c1565b6020026020010151611954565b6001016113e9565b50506001016113bf565b5050505050565b815183511461149b576040516311e86f7360e01b815260040160405180910390fd5b80518351146114bd576040516311e86f7360e01b815260040160405180910390fd5b825160005b81811015611472576115068582815181106114df576114df6126c1565b60200260200101518583815181106114f9576114f96126c1565b6020026020010151611a0e565b600083828151811061151a5761151a6126c1565b602002602001015151905060005b8181101561154d5761154587848151811061129e5761129e6126c1565b600101611528565b50506001016114c2565b60008260405160200161156a919061266b565b60408051601f1981840301815291815281516020928301206001600160a01b0387166000908152606784528281206001600160e01b03198316825290935290822054909250905b81811015610ce057836040516020016115ca919061266b565b60408051601f1981840301815291815281516020928301206001600160a01b0389166000908152606784528281206001600160e01b031988168252909352912080548390811061161c5761161c6126c1565b906000526020600020016040516020016116369190612757565b604051602081830303815290604052805190602001200361179f576001600160a01b03861660009081526067602090815260408083206001600160e01b03198716845290915290206116896001846127f2565b81548110611699576116996126c1565b600091825260208083206001600160a01b038a1684526067825260408085206001600160e01b031989168652909252922080549290910191839081106116e1576116e16126c1565b906000526020600020019080546116f790612687565b611702929190611c05565b506001600160a01b03861660009081526067602090815260408083206001600160e01b031987168452909152902080548061173f5761173f612817565b60019003818190600052602060002001600061175b9190611c90565b90557fa5e6b7a93ed253db6d2a06b5188982d74e373c1b7ef9ad991c6b619c2add4d2286868587604051611792949392919061282d565b60405180910390a1610ce0565b6001016115b1565b600154610100900460ff166118125760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b6064820152608401610451565b565b6001600160e01b0319808216900361186e5760405162461bcd60e51b815260206004820152601c60248201527f4552433136353a20696e76616c696420696e74657266616365206964000000006044820152606401610451565b6001600160e01b0319166000908152602081905260409020805460ff19166001179055565b6001600160a01b0381163b6119005760405162461bcd60e51b815260206004820152602d60248201527f455243313936373a206e657720696d706c656d656e746174696f6e206973206e60448201526c1bdd08184818dbdb9d1c9858dd609a1b6064820152608401610451565b6000805160206128c283398151915280546001600160a01b0319166001600160a01b0392909216919091179055565b61193883611a91565b6000825111806119455750805b1561069157610a248383611ad1565b600082604051602001611967919061266b565b60408051601f1981840301815291815281516020928301206001600160a01b0387166000908152606784528281206001600160e01b031983168252845291822080546001810182559083529183902085519194506119ca93920191850190611cca565b507fb8b75e5cd091bf22489bd28795bbe9e9fc969f14231a8172a0048223d4b7a4aa84848385604051611a00949392919061282d565b60405180910390a150505050565b6000611a1983610696565b905081606684604051611a2c919061266b565b90815260200160405180910390206001019080519060200190611a50929190611cca565b507ffaadb760342a16b35af55a84cf4830682730345e7808265fdaa03ad9e47a335e838284604051611a849392919061287e565b60405180910390a1505050565b611a9a81611893565b6040516001600160a01b038216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b60606001600160a01b0383163b611b395760405162461bcd60e51b815260206004820152602660248201527f416464726573733a2064656c65676174652063616c6c20746f206e6f6e2d636f6044820152651b9d1c9858dd60d21b6064820152608401610451565b600080846001600160a01b031684604051611b54919061266b565b600060405180830381855af49150503d8060008114611b8f576040519150601f19603f3d011682016040523d82523d6000602084013e611b94565b606091505b5091509150611bbc82826040518060600160405280602781526020016128e260279139611bc5565b95945050505050565b60608315611bd4575081611bfe565b825115611be45782518084602001fd5b8160405162461bcd60e51b81526004016104519190611fbc565b9392505050565b828054611c1190612687565b90600052602060002090601f016020900481019282611c335760008555611c80565b82601f10611c445780548555611c80565b82800160010185558215611c8057600052602060002091601f016020900482015b82811115611c80578254825591600101919060010190611c65565b50611c8c929150611d3e565b5090565b508054611c9c90612687565b6000825580601f10611cac575050565b601f0160209004906000526020600020908101906104ee9190611d3e565b828054611cd690612687565b90600052602060002090601f016020900481019282611cf85760008555611c80565b82601f10611d1157805160ff1916838001178555611c80565b82800160010185558215611c80579182015b82811115611c80578251825591602001919060010190611d23565b5b80821115611c8c5760008155600101611d3f565b80356001600160e01b031981168114611d6b57600080fd5b919050565b600060208284031215611d8257600080fd5b611bfe82611d53565b80356001600160a01b0381168114611d6b57600080fd5b600060208284031215611db457600080fd5b611bfe82611d8b565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f191681016001600160401b0381118282101715611dfb57611dfb611dbd565b604052919050565b60006001600160401b03831115611e1c57611e1c611dbd565b611e2f601f8401601f1916602001611dd3565b9050828152838383011115611e4357600080fd5b828260208301376000602084830101529392505050565b60008060408385031215611e6d57600080fd5b611e7683611d8b565b915060208301356001600160401b03811115611e9157600080fd5b8301601f81018513611ea257600080fd5b611eb185823560208401611e03565b9150509250929050565b600082601f830112611ecc57600080fd5b611bfe83833560208501611e03565b60008060408385031215611eee57600080fd5b82356001600160401b03811115611f0457600080fd5b611f1085828601611ebb565b925050611f1f60208401611d8b565b90509250929050565b600060208284031215611f3a57600080fd5b81356001600160401b03811115611f5057600080fd5b611f5c84828501611ebb565b949350505050565b60005b83811015611f7f578181015183820152602001611f67565b83811115610a245750506000910152565b60008151808452611fa8816020860160208601611f64565b601f01601f19169290920160200192915050565b602081526000611bfe6020830184611f90565b60008060008060608587031215611fe557600080fd5b84356001600160401b0380821115611ffc57600080fd5b818701915087601f83011261201057600080fd5b81358181111561201f57600080fd5b88602082850101111561203157600080fd5b6020830196508095505061204760208801611d8b565b9350604087013591508082111561205d57600080fd5b5061206a87828801611ebb565b91505092959194509250565b60006001600160401b0382111561208f5761208f611dbd565b5060051b60200190565b600082601f8301126120aa57600080fd5b813560206120bf6120ba83612076565b611dd3565b82815260059290921b840181019181810190868411156120de57600080fd5b8286015b8481101561211d5780356001600160401b038111156121015760008081fd5b61210f8986838b0101611ebb565b8452509183019183016120e2565b509695505050505050565b600082601f83011261213957600080fd5b813560206121496120ba83612076565b82815260059290921b8401810191818101908684111561216857600080fd5b8286015b8481101561211d5761217d81611d8b565b835291830191830161216c565b600082601f83011261219b57600080fd5b813560206121ab6120ba83612076565b82815260059290921b840181019181810190868411156121ca57600080fd5b8286015b8481101561211d5780356001600160401b038111156121ed5760008081fd5b6121fb8986838b0101612128565b8452509183019183016121ce565b6000806040838503121561221c57600080fd5b82356001600160401b038082111561223357600080fd5b61223f86838701612099565b9350602085013591508082111561225557600080fd5b50611eb18582860161218a565b600082601f83011261227357600080fd5b813560206122836120ba83612076565b82815260059290921b840181019181810190868411156122a257600080fd5b8286015b8481101561211d5780356001600160401b038111156122c55760008081fd5b6122d38986838b0101612099565b8452509183019183016122a6565b6000806000606084860312156122f657600080fd5b83356001600160401b038082111561230d57600080fd5b61231987838801612128565b9450602086013591508082111561232f57600080fd5b61233b87838801612099565b9350604086013591508082111561235157600080fd5b5061235e86828701612262565b9150509250925092565b6000806040838503121561237b57600080fd5b61238483611d8b565b915060208301356001600160401b0381111561239f57600080fd5b611eb185828601611ebb565b6000602080830181845280855180835260408601915060408160051b870101925083870160005b8281101561240057603f198886030184526123ee858351611f90565b945092850192908501906001016123d2565b5092979650505050505050565b60008060006060848603121561242257600080fd5b83356001600160401b038082111561243957600080fd5b61244587838801612099565b9450602086013591508082111561245b57600080fd5b61246787838801612099565b9350604086013591508082111561247d57600080fd5b5061235e8682870161218a565b600080600080600080600060e0888a0312156124a557600080fd5b6124ae88611d8b565b965060208801356001600160401b03808211156124ca57600080fd5b6124d68b838c01612099565b975060408a01359150808211156124ec57600080fd5b6124f88b838c01612099565b965060608a013591508082111561250e57600080fd5b61251a8b838c0161218a565b955060808a013591508082111561253057600080fd5b61253c8b838c01612128565b945060a08a013591508082111561255257600080fd5b61255e8b838c01612099565b935060c08a013591508082111561257457600080fd5b506125818a828b01612262565b91505092959891949750929550565b6000806000606084860312156125a557600080fd5b6125ae84611d8b565b92506125bc60208501611d8b565b91506125ca60408501611d53565b90509250925092565b6020808252602c908201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060408201526b19195b1959d85d1958d85b1b60a21b606082015260800190565b6020808252602c908201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060408201526b6163746976652070726f787960a01b606082015260800190565b6000825161267d818460208701611f64565b9190910192915050565b600181811c9082168061269b57607f821691505b6020821081036126bb57634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052603260045260246000fd5b8183823760009101908152919050565b6000602082840312156126f957600080fd5b5051919050565b6001600160a01b0383168152604060208201819052600090611f5c90830184611f90565b6060815260006127376060830186611f90565b6001600160a01b0394851660208401529290931660409091015292915050565b600080835481600182811c91508083168061277357607f831692505b6020808410820361279257634e487b7160e01b86526022600452602486fd5b8180156127a657600181146127b7576127e4565b60ff198616895284890196506127e4565b60008a81526020902060005b868110156127dc5781548b8201529085019083016127c3565b505084890196505b509498975050505050505050565b60008282101561281257634e487b7160e01b600052601160045260246000fd5b500390565b634e487b7160e01b600052603160045260246000fd5b6001600160a01b038516815260806020820181905260009061285190830186611f90565b6001600160e01b03198516604084015282810360608401526128738185611f90565b979650505050505050565b6060815260006128916060830186611f90565b82810360208401526128a38186611f90565b905082810360408401526128b78185611f90565b969550505050505056fe360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c6564a2646970667358221220554a1bee0ed5319574eda5541c8ab17ada55ea5ee1ef58600b33648195d4c04f64736f6c634300080d0033";

type DAOAccessControlConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DAOAccessControlConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DAOAccessControl__factory extends ContractFactory {
  constructor(...args: DAOAccessControlConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<DAOAccessControl> {
    return super.deploy(overrides || {}) as Promise<DAOAccessControl>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): DAOAccessControl {
    return super.attach(address) as DAOAccessControl;
  }
  override connect(signer: Signer): DAOAccessControl__factory {
    return super.connect(signer) as DAOAccessControl__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DAOAccessControlInterface {
    return new utils.Interface(_abi) as DAOAccessControlInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DAOAccessControl {
    return new Contract(address, _abi, signerOrProvider) as DAOAccessControl;
  }
}
